import { MessageCircle, MapPin, Clock, Phone, Instagram, Facebook, ExternalLink } from "lucide-react";
import { externalLinkHandler } from "../lib/openExternal";

const STORES = [
    {
        name: "Copiapó",
        address: "Bernardo O'Higgins 443, Local 12",
        city: "Copiapó, Atacama",
        hours: "Lun – Sáb · 10:00 – 20:00",
        maps: "https://www.google.com/maps/search/?api=1&query=Bernardo+O%27Higgins+443+local+12+Copiap%C3%B3+Chile",
    },
    {
        name: "La Serena",
        address: "Brasil 591, Local 4",
        city: "La Serena, Coquimbo",
        hours: "Lun – Sáb · 9:00 – 19:00",
        maps: "https://www.google.com/maps/search/?api=1&query=Brasil+591+local+4+La+Serena+Chile",
    },
];

const IG_URL = "https://instagram.com/ladulceriamexicana30";
const FB_URL = "https://facebook.com/ladulceriamexicana30";
const WA_URL = "https://wa.me/56998091369?text=Hola%2C%20quiero%20consultar%20por%20sus%20dulces";
const PHONE_PRIMARY = "+56 9 9809 1369";
const PHONE_SECONDARY = "+56 9 9785 5364";

export default function Contacto() {
    return (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="contacto-page">
            <div className="text-center mb-10">
                <span className="text-marigold font-semibold uppercase tracking-widest text-xs">Contacto</span>
                <h1 className="font-display text-4xl md:text-5xl font-semibold text-cocoa mt-1">
                    Visítanos o escríbenos
                </h1>
                <p className="text-muted-foreground mt-3 max-w-xl mx-auto">
                    Atendemos por WhatsApp, redes sociales y en nuestros dos locales en el norte de Chile. ¡Te esperamos!
                </p>
            </div>

            {/* Locales */}
            <div className="grid md:grid-cols-2 gap-6 mb-10">
                {STORES.map((s) => (
                    <a
                        key={s.name}
                        data-testid={`store-card-${s.name}`}
                        href={s.maps}
                        onClick={externalLinkHandler(s.maps)}
                        target="_blank"
                        rel="noreferrer"
                        className="group bg-white border border-border rounded-3xl p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all flex items-start gap-4"
                    >
                        <div className="w-14 h-14 rounded-2xl bg-mexred text-cocoa flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform shadow-md">
                            <MapPin className="w-6 h-6" />
                        </div>
                        <div className="flex-1">
                            <div className="flex items-center gap-2 mb-1">
                                <h3 className="font-display text-2xl font-semibold text-cocoa">{s.name}</h3>
                                <ExternalLink className="w-4 h-4 text-marigold opacity-0 group-hover:opacity-100 transition-opacity" />
                            </div>
                            <p className="text-cocoa font-medium">{s.address}</p>
                            <p className="text-sm text-muted-foreground">{s.city}</p>
                            <p className="text-sm text-cocoa mt-2 flex items-center gap-1">
                                <Clock className="w-3.5 h-3.5 text-marigold" />
                                <span className="font-semibold">{s.hours}</span>
                            </p>
                            <p className="text-xs text-marigold mt-2 font-semibold uppercase tracking-widest">
                                Abrir en Google Maps →
                            </p>
                        </div>
                    </a>
                ))}
            </div>

            {/* Canales */}
            <div className="grid md:grid-cols-2 gap-6">
                <a
                    data-testid="contact-whatsapp"
                    href={WA_URL}
                    onClick={externalLinkHandler(WA_URL)}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-[#25D366] text-white rounded-3xl p-8 shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all"
                >
                    <MessageCircle className="w-10 h-10 mb-3" />
                    <h3 className="font-display text-2xl font-semibold mb-1">WhatsApp</h3>
                    <p className="text-white/90 mb-3">Atención inmediata, lunes a sábado.</p>
                    <span className="font-mono text-lg font-bold">+56 9 9809 1369</span>
                </a>

                <div className="grid gap-4">
                    <a
                        data-testid="contact-instagram"
                        href={IG_URL}
                        onClick={externalLinkHandler(IG_URL)}
                        target="_blank"
                        rel="noreferrer"
                        className="bg-gradient-to-br from-marigold via-mexred to-marigold text-cocoa rounded-3xl p-6 shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all flex items-center gap-4"
                    >
                        <div className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center">
                            <Instagram className="w-6 h-6" />
                        </div>
                        <div>
                            <div className="font-display font-semibold">Instagram</div>
                            <div className="text-sm">@ladulceriamexicana30</div>
                        </div>
                    </a>
                    <a
                        data-testid="contact-facebook"
                        href={FB_URL}
                        onClick={externalLinkHandler(FB_URL)}
                        target="_blank"
                        rel="noreferrer"
                        className="bg-[#1877F2] text-white rounded-3xl p-6 shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all flex items-center gap-4"
                    >
                        <div className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center">
                            <Facebook className="w-6 h-6" />
                        </div>
                        <div>
                            <div className="font-display font-semibold">Facebook</div>
                            <div className="text-sm">ladulceriamexicana30</div>
                        </div>
                    </a>
                </div>
            </div>

            <div className="grid sm:grid-cols-3 gap-4 mt-8">
                <div className="bg-white border border-border rounded-2xl p-5 flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-marigold/15 text-marigold flex items-center justify-center shrink-0">
                        <Clock className="w-5 h-5" />
                    </div>
                    <div>
                        <div className="font-display font-semibold text-cocoa">Horarios</div>
                        <div className="text-muted-foreground text-sm leading-relaxed">
                            <span className="font-semibold text-cocoa">Copiapó:</span> Lun-Sáb 10:00 – 20:00<br />
                            <span className="font-semibold text-cocoa">La Serena:</span> Lun-Sáb 9:00 – 19:00
                        </div>
                    </div>
                </div>
                <a
                    href={`tel:${PHONE_PRIMARY.replace(/\s/g, "")}`}
                    className="bg-white border border-border rounded-2xl p-5 flex items-center gap-3 hover:border-mexred transition-colors"
                >
                    <div className="w-10 h-10 rounded-xl bg-mexyellow/40 text-cocoa flex items-center justify-center shrink-0">
                        <Phone className="w-5 h-5" />
                    </div>
                    <div>
                        <div className="font-display font-semibold text-cocoa">Teléfono 1</div>
                        <div className="text-muted-foreground text-sm">{PHONE_PRIMARY}</div>
                    </div>
                </a>
                <a
                    href={`tel:${PHONE_SECONDARY.replace(/\s/g, "")}`}
                    className="bg-white border border-border rounded-2xl p-5 flex items-center gap-3 hover:border-mexred transition-colors"
                >
                    <div className="w-10 h-10 rounded-xl bg-mexred/15 text-mexred flex items-center justify-center shrink-0">
                        <Phone className="w-5 h-5" />
                    </div>
                    <div>
                        <div className="font-display font-semibold text-cocoa">Teléfono 2</div>
                        <div className="text-muted-foreground text-sm">{PHONE_SECONDARY}</div>
                    </div>
                </a>
            </div>
        </div>
    );
}
